<script setup lang="ts">
export interface MenuSelectionLanguageNewProps {
  availableLocales: TAvailableLocale[];
}

const emit = defineEmits(["back"]);

const { t, locale: currentLocale, setLocale } = useI18n();
const props = defineProps<MenuSelectionLanguageNewProps>();

function changeLocale(locale: TAvailableLocale) {
  // @ts-expect-error - setLocale accepts string but TypeScript infers strict locale type from config
  setLocale(locale);
  emit("back");
}

function onBackClick() {
  emit("back");
}
</script>

<template>
  <UList>
    <UListItem
      :on-click-close-menu="false"
      size="lg"
      @click="onBackClick"
    >
      <template #leading>
        <IconChevronRight class="transform rotate-180 text-black dark:text-white" :width="8" :height="8" />
      </template>
      <span class="font-bold text-base">{{ t("locales.title") }}</span>
    </UListItem>
    <UDivider lighter />
    <UListItem
      v-for="locale in props.availableLocales"
      :key="locale"
      size="md"
      :trailing-icon="{ name: locale === (currentLocale as string) ? 'check' : 'empty', class: 'text-blue-500' }"
      @click="() => changeLocale(locale)"
    >
      <span class="text-base">{{ t(`locales.${locale}`) }}</span>
    </UListItem>
  </UList>
</template>
